import $ from "jquery";
$(".link-container .tab-link").on("click", function () {
  var tabpane = $(this).attr("id");

  tabpane = tabpane.replace("link-", "");
  tabpane = "tab-" + tabpane;

  $(".link-container .tab-link").removeClass("active");
  $(this).addClass("active");

  if (!$("#" + tabpane).hasClass("active")) {
    $(".tab-panes > .tab").removeClass("active");
    $("#" + tabpane).addClass("active");
    // $('#'+tabpane +' .slider-block').slick('refresh');
  }

  jQuery(".lozad").each(function () {
    var src = jQuery(this).attr("data-src");
    jQuery(this).attr("src", src);
  });
});

$(".info-block .tab-link").on("click", function () {
  var tabpane = $(this).attr("id");

  tabpane = tabpane.replace("link-", "");
  tabpane = "tab-" + tabpane;

  $(".info-block .tab-link").removeClass("active");
  $(this).addClass("active");

  if (!$("#" + tabpane).hasClass("active")) {
    $(".block-tabs .tab").removeClass("active");
    $("#" + tabpane).addClass("active");
  }
});

// function removeActiveTab(tabletScreen) {
//   if (tabletScreen.matches) {
//     $('.tab').removeClass('active');
//   } else {
//   }
// }
// var tabletScreen = window.matchMedia("(max-width: 768px)");
// removeActiveTab(tabletScreen);
// tabletScreen.addListener(removeActiveTab);
